import { C, TESTIMONIALS } from "../data/content";

export const Takeaways = () => (
  <section className="py-28 px-6 lg:px-12" data-testid="takeaways-section">
    <div className="max-w-[1200px] mx-auto">
      <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-6">[007] — THE OUTCOME</p>
      <h2 className="h1-display text-[clamp(28px,3.4vw,48px)] mb-12">WHAT YOU'LL WALK AWAY WITH</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {C.takeaways.map((t, i) => (
          <div key={i} className="aud-card p-7" data-testid={`takeaway-card-${i + 1}`}>
            <span className="text-3xl block mb-5">{t.icon}</span>
            <h3 className="font-black uppercase text-[14px] tracking-wide mb-3">{t.title}</h3>
            <p className="text-[13px] text-white/45 leading-relaxed">{t.desc}</p>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-3 gap-4 mt-14">
        {TESTIMONIALS.map((t, i) => (
          <div key={i} className="glass-card p-7 flex flex-col gap-4" data-testid={`testimonial-card-${i + 1}`}>
            <div>
              <div className="flex items-center justify-between">
                <p className="font-black text-[15px]">{t.name}</p>
                <p className="text-[var(--accent)] tracking-[0.15em] text-sm">★★★★★</p>
              </div>
              <p className="mono text-[10px] text-white/30 mt-1">{t.date}</p>
            </div>
            <p className="text-[13px] text-white/55 leading-relaxed italic">"{t.text}"</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
